export default "__VITE_ASSET__DbsXsYJJ__"